import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { getGemsTokenContract } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const AllowanceGems = () => {
  // const [balance, setBalance] = useState(null)
  //   const { account } = useWeb3React();
  const web3 = useWeb3();
  const contractAddress = Environment.GemsStaking1;
  
  const allowanceGems = useCallback(
    async (account, tokenAddress, decimals) => {
      const contract = getGemsTokenContract(tokenAddress, web3);

      // console.log(tokenAddress,account,tokenAddress,decimals,'noor222222');
      try {
        const buy = await contract.methods
          .allowance(account, contractAddress)
          .call();

        const allow = parseInt(buy.toString()) / 10 ** decimals;

        return allow;
      } catch (error) {
        throw error;
      }
    },
    [web3]
  );
  return { allowanceGems: allowanceGems };
};
export default AllowanceGems;
